import { render } from "./DocActivity.vue?vue&type=template&id=74d04894&scoped=true&ts=true"
import script from "./DocActivity.vue?vue&type=script&lang=ts"
export * from "./DocActivity.vue?vue&type=script&lang=ts"

import "./DocActivity.vue?vue&type=style&index=0&id=74d04894&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d04894"]])

export default __exports__